export default {
  title: 'Top-Artikel',
  columns: {
    name: 'Artikel',
    quantity: 'Anzahl',
    amount: 'Summe',
  },
};
